module.exports = __webpack_public_path__ + "img/microsoft-brands.21f65355.svg";